import {AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2, ViewChild} from '@angular/core';
import {Router} from '@angular/router';

import {MenuItems} from '../../../../Menu/MenuItems/MenuItems';

@Component({
  selector: 'app-header-menu',
  templateUrl: './HeaderMenu.component.html',
  styleUrls: ['./HeaderMenu.component.scss']
})

export class MenuComponent implements OnInit, AfterViewInit {

  @ViewChild('headerMenu') headerMenu: ElementRef;

  @Input() stickyClass: any;
  currentUrl: any;

  constructor(public menuItems: MenuItems,
              private renderer: Renderer2,
              private router: Router) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.currentUrl = this.router.url;
    // header responsive
    if ((
        this.currentUrl !== '/session/comingsoon') &&
      (this.currentUrl !== '/session/maintenance') &&
      (this.currentUrl !== '/session/login') &&
      (this.currentUrl !== '/session/signup2')
    ) {


      const menuItems = this.headerMenu.nativeElement.querySelectorAll('.menu-item-has-child');

      for (let i = 0; i < menuItems.length; i++) {

        (index => {
          menuItems[index].addEventListener('click', event => {
            event.stopPropagation();
            if (menuItems[index] !== undefined) {
              menuItems[index].classList.toggle('opened-submenu');
            }
          });
        })(i);
      }


    }

  }

  navigateAndReload(path: string) {
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.router.navigate([path]);
    });
  }


}
